





























































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { moneyDirective, moneyMask } from '@/components/inputs/MoneyInput.vue'
import FileInput from '@/components/inputs/FileInput.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ElectronicRecordConfirm from './ElectronicRecordConfirm.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { DATE_MASK, PHONE_MASK, ZIP_MASK } from '@/constants'
import { IFacility, IFacilityPaymentAccount, US_STATES_LIST } from '@zunta/configurations'
import {
  validateDate,
  validateEIN,
  validateEmail,
  validatePhone,
  validateSSN,
  validateWebsite,
  validateZip
} from '@/utils/helpers'
import { PaymentsModule } from '@/store/modules/payments.module'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import { minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  components: {
    ModalV2,
    LoaderWrapper,
    SelectV2,
    InputValidator,
    InputV2,
    Card,
    FileInput,
    Checkbox,
    ElectronicRecordConfirm
  },
  directives: {
    moneyDirective
  }
})
export default class FacilityPaymentSettingsConfigureV2 extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  user: User = Api.getUser() as User
  PHONE_MASK: string = PHONE_MASK
  ZIP_MASK: string = ZIP_MASK
  DATE_MASK: string = DATE_MASK

  errors: string[] = []
  isSignContractLoaded: boolean = false
  paymentVoidedCheckFile: File | null = null
  withdrawnPaymentVoidedCheckFile: File | null = null
  isCreatingAccount: boolean = false
  isLoading: boolean = false
  shouldConfirmElectronicRecord: boolean = false
  shouldMaskDob: boolean = false
  shouldMaskSsn: boolean = false
  ssnUntached: boolean = true
  dobUntached: boolean = true
  moneyMask: any = moneyMask

  paymentAccountToCopy: any = null

  paymentAccountData: Partial<IFacilityPaymentAccount> = {
    corporationType: '',
    businessName: '',
    ein: '',
    address: '',
    city: '',
    state: undefined,
    zip: '',
    phone: '',
    website: '',
    email: '',
    underDBA: false,
    dbaName: '',
    dbaAddress: '',
    dbaCity: '',
    dbaState: undefined,
    dbaZip: '',
    signerLegalFirstName: '',
    signerLegalLastName: '',
    signerDob: undefined,
    signerSsn: '',
    signerAddress: '',
    signerCity: '',
    signerState: undefined,
    signerZip: '',
    signerPhone: '',
    routingNumber: '',
    accountNumber: '',
    withdrawnRoutingNumber: '',
    withdrawnAccountNumber: '',
    dateIncorporated: undefined,
    ccAverageMonthlyVolume: 50000,
    ccAverageTransaction: 5000,
    ccHighTicket: 100000,
    echeckAverageMonthlyVolume: 50000,
    echeckAverageTransaction: 5000,
    echeckHighTicket: 25000,
    echeckMonthlyNumber: 50,
    ccTransactionPercentage: undefined,
    echeckPocName: undefined,
    echeckPocEmail: undefined,
    echeckPocPhone: undefined
  }
  popupToken: string = ''

  validations (): any {
    return {
      paymentAccountData: {
        businessName: {
          required
        },
        ein: {
          required: (value: any) => validateEIN(value)
        },
        dateIncorporated: {
          valid: (value: any) => validateDate(value)
        },
        corporationType: {
          required
        },
        address: {
          required
        },
        city: {
          required
        },
        state: {
          required
        },
        zip: {
          valid: (value: any) => validateZip(value)
        },
        phone: {
          valid: (value: any) => validatePhone(value)
        },
        website: {
          valid: (value: any) => !value || validateWebsite(value)
        },
        email: {
          required
        },
        dbaName: {
          // required: requiredIf(() => this.paymentAccountData.underDBA)
        },
        dbaAddress: {
          // required: requiredIf(() => this.paymentAccountData.underDBA)
        },
        dbaCity: {
          // required: requiredIf(() => this.paymentAccountData.underDBA)
        },
        dbaState: {
          // required: requiredIf(() => this.paymentAccountData.underDBA)
        },
        dbaZip: {
          // required: requiredIf(() => this.paymentAccountData.underDBA),
          valid: (value: any) => !value || validateZip(value)
        },
        signerLegalFirstName: {
          required
        },
        signerLegalLastName: {
          required
        },
        signerDob: {
          required,
          valid: (value: any) => validateDate(value)
        },
        signerSsn: {
          required,
          valid: (value: any) => validateSSN(value)
        },
        signerAddress: {
          required
        },
        signerCity: {
          required
        },
        signerState: {
          required
        },
        signerZip: {
          required,
          valid: (value: any) => validateZip(value)
        },
        signerPhone: {
          required,
          valid: (value: any) => validatePhone(value)
        },
        echeckPocName: {
          // required
        },
        echeckPocEmail: {
          // required,
          valid: (value: any) => !value || validateEmail(value)
        },
        echeckPocPhone: {
          // required,
          valid: (value: any) => !value || validatePhone(value)
        },
        ccAverageMonthlyVolume: {
          numeric,
          required
        },
        ccAverageTransaction: {
          numeric,
          required
        },
        ccHighTicket: {
          required,
          numeric
        },
        echeckAverageMonthlyVolume: {
          required,
          numeric
        },
        echeckAverageTransaction: {
          required,
          numeric
        },
        echeckHighTicket: {
          required,
          numeric
        },
        echeckMonthlyNumber: {
          required,
          numeric
        },
        routingNumber: {
          required,
          numeric,
          valid: (value: any) => value && minLength(9)
        },
        accountNumber: {
          numeric,
          required
        },
        voidedCheckFileName: {
          // todo empty
        },
        withdrawnRoutingNumber: {
          required: requiredIf(() => this.paymentAccountData.withdrawnRoutingNumber || this.paymentAccountData.withdrawnAccountNumber || this.withdrawnPaymentVoidedCheckFile),
          valid: (value: any) => !value || minLength(9),
          numeric
        },
        withdrawnAccountNumber: {
          numeric,
          required: requiredIf(() => this.paymentAccountData.withdrawnRoutingNumber || this.paymentAccountData.withdrawnAccountNumber || this.withdrawnPaymentVoidedCheckFile)
        }
      },
      withdrawnVoidedCheckFile: {
        // required: requiredIf(() => this.paymentAccountData.withdrawnRoutingNumber || this.paymentAccountData.withdrawnAccountNumber)
      }
    }
  }

  get stateList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      value: stateShortName,
      key: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  get facilityId () {
    return this.$route.params.id
  }

  get facilityPaymentAccount () {
    return this.$store.state.facility.facilityPaymentAccount
  }

  get facilitiesPaymentAccountsList () {
    const facilitiesPaymentAccounts = this.$store.state.facility.facilitiesPaymentAccounts || []
    return facilitiesPaymentAccounts.map((item: IFacilityPaymentAccount) => {
      const facilityId = typeof item.facility === 'number' ? item.facility : item.facility.id
      return {
        value: facilityId,
        key: facilityId,
        content: item.businessName
      }
    })
  }

  get isDisabled () {
    if (!this.$store.state.facility.facilityPaymentAccount) {
      return false
    }
    return this.$store.state.facility.facilityPaymentAccount.willowAccountId && !this.$store.state.facility.facilityPaymentAccount.enableEditing
  }

  get screenHeight () {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  }

  get isRootAccess () {
    return this.user.isRootAccess()
  }

  async mounted () {
    try {
      this.isLoading = true
      if (this.facilityId) {
        // @ts-ignore
        await this.facilityModuleInstance.getFacilityList({})
        await this.facilityModuleInstance.fetchFacilitiesPaymentAccounts(this.$store.state.facility.facilities.map((f: IFacility) => f.id))
        // @ts-ignore
        await this.facilityModuleInstance.fetchFacilityPaymentAccount(Number(this.facilityId))
      }

      if (this.facilityPaymentAccount) {
        Object.keys(this.facilityPaymentAccount).forEach((fieldName: string) => {
          (this.paymentAccountData as any)[fieldName] = this.facilityPaymentAccount[fieldName]
          if (['dateIncorporated', 'signerDob'].includes(fieldName)) {
            this.setDateField(fieldName, this.facilityPaymentAccount[fieldName])
          }
          if (fieldName === 'signerDob' && this.facilityPaymentAccount[fieldName]) {
            this.shouldMaskDob = true
          }
          if (fieldName === 'signerSsn' && this.facilityPaymentAccount[fieldName]) {
            this.shouldMaskSsn = true
          }
        })
      } else {
        const facilityData = this.facilityModuleInstance.selectedFacility
        if (!facilityData) {
          this.isLoading = false
          return
        }
        this.paymentAccountData.businessName = facilityData.name
        this.paymentAccountData.city = facilityData.city
        this.paymentAccountData.state = facilityData.state
        this.paymentAccountData.zip = facilityData.zip ? facilityData.zip.split('-')[0] : facilityData.zip
        this.paymentAccountData.phone = facilityData.phone
        this.paymentAccountData.zip = facilityData.zip ? facilityData.zip.split('-')[0] : facilityData.zip
        this.paymentAccountData.website = facilityData.website
        this.paymentAccountData.address = facilityData.street
        this.paymentAccountData.email = facilityData.email
      }
    } finally {
      this.isLoading = false
    }
  }

  checkShouldMaskField (field: string, value: any) {
    if (field === 'signerDob' && this.dobUntached) {
      this.dobUntached = value !== ''
    } else if (field === 'signerSsn' && this.ssnUntached) {
      this.ssnUntached = value !== ''
    }
  }

  handleSignContractLoad (event: any) {
    const iframe: any = event.target
    const intervalId = setInterval(() => {
      if (iframe.contentWindow) {
        clearInterval(intervalId)
        this.isSignContractLoaded = true
      }
    }, 100)
  }

  setDateField (propName: string, date: any) {
    if (date instanceof Date) {
      (this.paymentAccountData as any)[propName] = new Date(date).toLocaleDateString('en-US')
      this.$forceUpdate()
    } else if (date && date.includes('-')) {
      (this.paymentAccountData as any)[propName] = new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' })
    } else if (date) {
      (this.paymentAccountData as any)[propName] = date.replace(/-/g, '/')
    } else {
      (this.paymentAccountData as any)[propName] = ''
    }
  }

  setVoidedCheckFile (file: File) {
    this.paymentVoidedCheckFile = file
  }

  setWithdrawVoidedCheckFile (file: File) {
    this.withdrawnPaymentVoidedCheckFile = file
  }

  resetPopupToken () {
    this.popupToken = ''
  }

  async enableConfirmElectronicRecord () {
    this.$v.$touch()

    if (this.$v.$anyError) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: `Fill out the highlighted fields and try again`,
        header: `Missing Fields`,
        icon: 'warning'
      })
      return
    }

    const banks = await this.paymentsModuleInstance.getBanks({
      routing: this.paymentAccountData.withdrawnRoutingNumber
    })

    if (!banks || !banks.length) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Please, check routing number',
        header: `Routing number is invalid`,
        icon: 'warning'
      })
      return
    }

    this.shouldConfirmElectronicRecord = true
  }

  async save (isDraft = false) {
    try {
      this.isLoading = true
      this.$v.$touch()
      if (this.$v.$anyError && !isDraft) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: `Fill out the highlighted fields and try again`,
          header: `Missing Fields`,
          icon: 'warning'
        })
        return
      }

    const banksRoutingNumber = await this.paymentsModuleInstance.getBanks({
      routing: this.paymentAccountData.routingNumber
    })

    if ((!banksRoutingNumber || !banksRoutingNumber.length) && !isDraft) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Please, check routing number',
        header: `Routing number is invalid`,
        icon: 'warning'
      })
      return
    }

    if (this.paymentAccountData.withdrawnRoutingNumber) {
      const banksWithdrawnRoutingNumber = await this.paymentsModuleInstance.getBanks({
        routing: this.paymentAccountData.withdrawnRoutingNumber
      })
      if ((!banksWithdrawnRoutingNumber || !banksWithdrawnRoutingNumber.length) && !isDraft) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Please, check withdrawn routing number',
          header: `Routing number is invalid`,
          icon: 'warning'
        })
        return
      }
    }

      const replaceWhitespace = (str: string | any): number => {
        return str ? Number(str.toString().replace(/\s/g, '')) : str
      }

      const replaceNumWithNullIfEmpty = (num: string | number): number | undefined => {
        // Should never be isNaN, since its number validation inside input
        return (typeof num === 'string' && num === '') ? undefined : Number(num)
      }

      this.isCreatingAccount = true

      this.paymentAccountData.ccAverageMonthlyVolume = replaceWhitespace(this.paymentAccountData.ccAverageMonthlyVolume)
      this.paymentAccountData.ccAverageTransaction = replaceWhitespace(this.paymentAccountData.ccAverageTransaction)
      this.paymentAccountData.ccHighTicket = replaceWhitespace(this.paymentAccountData.ccHighTicket)
      this.paymentAccountData.echeckAverageMonthlyVolume = replaceWhitespace(this.paymentAccountData.echeckAverageMonthlyVolume)
      this.paymentAccountData.echeckAverageTransaction = replaceWhitespace(this.paymentAccountData.echeckAverageTransaction)
      this.paymentAccountData.echeckHighTicket = replaceWhitespace(this.paymentAccountData.echeckHighTicket)
      this.paymentAccountData.echeckMonthlyNumber = replaceWhitespace(this.paymentAccountData.echeckMonthlyNumber)

      // 7 values below are numeric in DB -> replace empty string values with undefined
      this.paymentAccountData.ccAverageMonthlyVolume = replaceNumWithNullIfEmpty(this.paymentAccountData.ccAverageMonthlyVolume)
      this.paymentAccountData.ccAverageTransaction = replaceNumWithNullIfEmpty(this.paymentAccountData.ccAverageTransaction)
      this.paymentAccountData.ccHighTicket = replaceNumWithNullIfEmpty(this.paymentAccountData.ccHighTicket)
      this.paymentAccountData.echeckAverageMonthlyVolume = replaceNumWithNullIfEmpty(this.paymentAccountData.echeckAverageMonthlyVolume)
      this.paymentAccountData.echeckAverageTransaction = replaceNumWithNullIfEmpty(this.paymentAccountData.echeckAverageTransaction)
      this.paymentAccountData.echeckHighTicket = replaceNumWithNullIfEmpty(this.paymentAccountData.echeckHighTicket)
      this.paymentAccountData.echeckMonthlyNumber = replaceNumWithNullIfEmpty(this.paymentAccountData.echeckMonthlyNumber)

      const data = {
        data: {
          ...this.paymentAccountData,
          facility: parseInt(this.facilityId)
        },
        voidedCheckFile: this.paymentVoidedCheckFile,
        withdrawnVoidedCheckFile: this.withdrawnPaymentVoidedCheckFile
      }

      let response
      this.shouldConfirmElectronicRecord = false

      if (!isDraft) {
        response = await this.facilityModuleInstance.saveFacilityPaymentAccount(data)
      } else {
        response = await this.facilityModuleInstance.saveFacilityPaymentAccountDraft(data)
      }

      this.isSignContractLoaded = false
      this.isCreatingAccount = false

      if (response.status === 'OK') {
        if (response.popupToken) {
          this.popupToken = response.popupToken
        }
        await this.facilityModuleInstance.fetchFacilityPaymentAccount(parseInt(this.facilityId, 10))
        this.paymentAccountData.id = this.facilityPaymentAccount.id
        if (isDraft) {
          this.$eventBus.$emit('notify', {
            color: 'var(--status-success-color)',
            message: 'Data saved',
            header: `Payment Account`,
            icon: 'success'
          })
        }
      } else if (response.message && response.message.length) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: response.message.join('\n'),
          header: `Payment Account`,
          icon: 'warning'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Error',
          header: `Payment Account`,
          icon: 'warning'
        })
      }
    } finally {
      this.isLoading = false
    }
  }

  fillSignerInformation (value: any) {
    this.paymentAccountToCopy = value
    const paymentAccount = this.$store.state.facility.facilitiesPaymentAccounts.find((el: IFacilityPaymentAccount) => {
      const facilityId = typeof el.facility === 'number' ? el.facility : el.facility.id
      return facilityId === value
    })
    if (paymentAccount) {
      this.paymentAccountData.signerLegalFirstName = paymentAccount.signerLegalFirstName
      this.paymentAccountData.signerLegalLastName = paymentAccount.signerLegalLastName
      this.paymentAccountData.signerDob = paymentAccount.signerDob
      this.paymentAccountData.signerSsn = paymentAccount.signerSsn
      this.paymentAccountData.signerAddress = paymentAccount.signerAddress
      this.paymentAccountData.signerCity = paymentAccount.signerCity
      this.paymentAccountData.signerState = paymentAccount.signerState
      this.paymentAccountData.signerZip = paymentAccount.signerZip
      this.paymentAccountData.signerPhone = paymentAccount.signerPhone
      this.paymentAccountData.echeckPocName = paymentAccount.echeckPocName
      this.paymentAccountData.echeckPocEmail = paymentAccount.echeckPocEmail
      this.paymentAccountData.echeckPocPhone = paymentAccount.echeckPocPhone
    }
  }
}
